import { ReactElement } from 'react';

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Box,
  PopoverProps,
  Portal,
  PopoverContentProps,
} from '@vimeo/bokeh';

interface IBokehPopoverProps extends Partial<PopoverProps> {
  triggerContent: ReactElement;
  content?: ReactElement;
  inPortal?: boolean;
  isLazy?: boolean;
  zIndex?: number | string;
  contentProps?: PopoverContentProps['rootProps'];
}

export function BokehPopover({
  inPortal = false,
  isLazy = true,
  triggerContent,
  content,
  gutter = 12,
  isOpen,
  contentProps,
  zIndex = 'popover',
  ...props
}: IBokehPopoverProps) {
  return (
    <Popover isOpen={isOpen} isLazy={isLazy} gutter={gutter} {...props}>
      <PopoverTrigger>{triggerContent}</PopoverTrigger>
      {inPortal ? (
        <Portal>
          {isOpen ? (
            <Box position={'absolute'} zIndex={zIndex}>
              <PopoverContent>{content}</PopoverContent>
            </Box>
          ) : null}
        </Portal>
      ) : (
        <Box position={'absolute'} zIndex={zIndex}>
          <PopoverContent rootProps={contentProps}>{content}</PopoverContent>
        </Box>
      )}
    </Popover>
  );
}
